<template>
  <transition name="toast-fade">
    <div
      v-if="toastConfig.visible"
      :class="['toast-container', `toast-${toastConfig.type}`]"
    >
      <div class="toast-message">
        {{ toastConfig.message }}
      </div>
      <button class="toast-close-button" @click="closeToast">&times;</button>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'GlobalToast',
  computed: {
    ...mapGetters('toast', ['toastConfig']),
  },
  methods: {
    ...mapActions('toast', ['hideToast']),
    closeToast() {
      this.hideToast();
    },
  },
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 15px 20px;
  border-radius: 4px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999; /* Garante que o toast fique sobre outros elementos */
  min-width: 250px;
  max-width: 400px;
}

/* Estilos baseados nos tipos comuns do Inspinia/Toastr */
.toast-info {
  background-color: #2f96b4; /* Azul Inspinia Info */
}
.toast-success {
  background-color: #5cb85c; /* Verde Inspinia Success */
}
.toast-warning {
  background-color: #f8ac59; /* Amarelo Inspinia Warning */
}
.toast-error {
  background-color: #d9534f; /* Vermelho Inspinia Error/Danger */
}

.toast-message {
  flex-grow: 1;
  margin-right: 15px;
}

.toast-close-button {
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.toast-close-button:hover {
  opacity: 0.8;
}

/* Animação de fade */
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
.toast-fade-enter-to,
.toast-fade-leave {
  opacity: 1;
  transform: translateY(0);
}
</style>
